import { Observable } from 'rxjs';
import { DynamicModification } from '../../../models/dynamic-modification';
import { ViewerService } from '../../../services/viewer.service';
import { Operation, OperationType } from './operation';

export class AddDmOperation implements Operation {

    public shadowPlaceholder: HTMLDivElement;
    name: string;
    operationType: OperationType = OperationType.ADD_DM;
    stepId: string;
    private viewerService: ViewerService;
    private appeazUrl: string;
    private readonly dynamicModifications: Array<DynamicModification>;
    private idAppeaz: number;
    private appeazRole: string;
    private rank: number;
    private readonly isPhotoImportOperation: boolean;

    constructor(viewerService: ViewerService, name: string,
        idAppeaz: number,
        appeazUrl: string,
        appeazRole: string,
        stepId: string,
        dynamicModifications: Array<DynamicModification>,
        rank: number,
        shadowPlaceholder: HTMLDivElement, isPhotoImportOperation: boolean) {
        this.name = name;
        this.viewerService = viewerService;
        this.appeazUrl = appeazUrl;
        this.stepId = stepId;
        this.dynamicModifications = dynamicModifications;
        this.idAppeaz = idAppeaz;
        this.appeazRole = appeazRole;
        this.rank = rank;
        this.shadowPlaceholder = shadowPlaceholder;
        this.isPhotoImportOperation = isPhotoImportOperation;
    }

    execute(): Observable<number> {
        return this.viewerService.addDynamicModification(this.appeazUrl, this.stepId, this.dynamicModifications);
    }

    getName(): string {
        return this.name;
    }

    getDynamicModification(): Array<DynamicModification> {
        return this.dynamicModifications;
    }

    getRank(): any {
        return this.rank;
    }

    getOperationType(): OperationType {
        return this.operationType;
    }

    getStepId(): string {
        return this.stepId;
    }

    isImportPhotoOperation(): boolean {
        return this.isPhotoImportOperation;
    }

}
